import { ColorOptions } from '@jfs/ui-new'
import * as React from 'react'
import { FC } from 'react'
import { CardComponent } from '../../comps/CreditCard/SavedCards/AddCard'
import { Modal } from '../../comps/Modal'
import { CardVendors } from '../../utils'
interface CardDetails {
  cardNumber: string
  cardHolderName: string
  expiry: string
  cvv: string
  isSaveCard?: boolean
  token?: string
  scheme?: number
  type?: number
  isNewCard?: boolean
}
interface AddNewCardProps {
  show: Boolean
  onDismiss: () => void
  onPayment: (values: CardDetails) => void
  onCardNumberBlur?: (cardVendor: CardVendors, cardNumber: string) => void
  isValid?: boolean
  errMsg?: string
  amount?: string
  hide?: Boolean
  onCardNumberChange?: (cardNumber: string) => void
  theme?: any
  fotterComp?: React.ReactNode
  isEMI?: boolean
  isEMIEligible?: boolean
  emiTotalAmount?: string
  isLoading?: boolean
  errorColor?: ColorOptions
  addlFotterComp?: React.ReactNode
  isPayButtonEnable?: boolean
  isEMIPlanSelected?: boolean
}
const ModalCard: FC<AddNewCardProps> = ({
  show,
  onDismiss,
  onPayment,
  onCardNumberBlur,
  onCardNumberChange,
  amount,
  isValid,
  errMsg,
  theme,
  fotterComp,
  isEMI,
  isEMIEligible,
  emiTotalAmount,
  isLoading,
  errorColor,
  addlFotterComp,
  isPayButtonEnable,
  isEMIPlanSelected,
}: AddNewCardProps) => {
  console.log('ModalCard', addlFotterComp)
  return (
    <Modal
      testID="cancel-modal"
      type={'BottomTop'}
      title={'Add New Card'}
      show={true}
      isFullWidth
      onDismiss={onDismiss}
      theme={theme}>
      <CardComponent
        hide={!show}
        onPayment={onPayment}
        onCardNumberBlur={onCardNumberBlur}
        onCardNumberChange={onCardNumberChange}
        amount={amount}
        isValid={isValid}
        isLoading={isLoading}
        errorColor={errorColor}
        errMsg={errMsg}
        theme={theme}
        isEMIEligible={isEMIEligible}
        isEMI={isEMI}
        btnTitle={isEMIPlanSelected ? `Pay ${emiTotalAmount || amount} through EMI` : undefined}
        fotterComp={fotterComp}
        addlFotterComp={addlFotterComp}
        isPayButtonEnable={isPayButtonEnable}
        showSCCheckBox={true}
      />
    </Modal>
  )
}
export { ModalCard }
